import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "to-cert-item",
  templateUrl: "to-cert-item.html",
  styleUrls: ["../../shortcut-menu.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, AngularSvgIconModule],
})
export class ToCertItem {
  private router = inject(Router);

  protected navigateToCert() {
    this.router.navigate(["cert", "ddos"]);
  }
}
